import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get } from "micro-dash";

import modalTypes from "../../constants/modalTypes";
import { fetchCrematoryIfNeeded } from "../../actions/crematories";
import { deleteDevice } from "../../actions/devices";
import { showModal } from "../../actions/modals";
import { showToast } from "../../actions/toasts";
import { getCrematoryRooms } from "../../selectors/rooms";
import { getCrematoryDevices } from "../../selectors/devices";

import DeviceOverviewContainer from "./DeviceOverviewContainer";

function getCrematoryIdFromRouteParams(match) {
    const id = get(match, ["params", "crematoryID"], null);

    if (Number.isNaN(parseInt(id))) {
        return null;
    }

    return parseInt(id);
}

const mapStateToProps = (state, props) => {
    const crematoryId = getCrematoryIdFromRouteParams(props.match);
    const crematory = state.entities.crematories.byId[crematoryId];
    let rooms = [];
    let devices = [];

    if (crematory && crematory.item) {
        rooms = getCrematoryRooms(state, crematoryId);
        devices = getCrematoryDevices(state, rooms.map(room => room.id));
    }

    return {
        crematory,
        devices,
        rooms
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const crematoryId = getCrematoryIdFromRouteParams(props.match);

    return {
        fetchActiveCrematory: () =>
            dispatch(fetchCrematoryIfNeeded(crematoryId)),
        onDeviceDeleted: id => dispatch(deleteDevice(id)),
        showForm: device =>
            dispatch(
                showModal({
                    type: modalTypes.DEVICE,
                    props: { crematoryId, device }
                })
            ),
        showToast: options => {
            dispatch(showToast(options));
        }
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DeviceOverviewContainer)
);
